import { CMS_API_URL } from 'config';
import { MenuTab } from './cmsContent.types';

export function computeCmsResourceId(endpoint: string) {
  return `${CMS_API_URL}${endpoint}`;
}

/**
 * Prefetches the card images in order to improve the user experience.
 * @param menuTabs
 * @see https://developer.mozilla.org/en-US/docs/Web/HTTP/Link_prefetching_FAQ
 */
export function prefetchSlideInMenuImages(menuTabs: MenuTab[] | undefined) {
  if (!menuTabs) {
    return;
  }

  const images: string[] = [];

  for (let i = 0, len = menuTabs.length; i < len; i++) {
    const cards = menuTabs[i]?.cards;

    if (cards) {
      for (let j = 0, cardsLen = cards.length; j < cardsLen; j++) {
        const cardImageSrc = cards[i]?.image;

        if (cardImageSrc && typeof cardImageSrc === 'string') {
          images.push(cardImageSrc);
        }
      }
    }
  }

  if (images.length < 1) {
    return;
  }

  const fragment = document.createDocumentFragment();

  for (let i = 0, len = images.length; i < len; i++) {
    const linkElem = document.createElement('link');

    linkElem.setAttribute('rel', 'prefetch');
    linkElem.setAttribute('href', images[i]);

    fragment.appendChild(linkElem);
  }

  document.head.appendChild(fragment);
}
